var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAddToCalendar = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 21,
  viewBox: "0 0 20 21",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "o9srnp685a",
  d: "M.667.899h16V2.1h-16z"
}), /*#__PURE__*/React.createElement("path", {
  id: "dgqs0ezi3c",
  d: "M.578.857h1.177v4.286H.578z"
}), /*#__PURE__*/React.createElement("path", {
  id: "xxf6v25jld",
  d: "M.578.857h1.177v4.286H.578z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.667 5.443v6.7h-1.18v-6.7c0-1.11-.86-2.02-1.93-2.02H3.777c-1.07 0-1.93.91-1.93 2.02v10.51c0 1.12.86 2.02 1.93 2.02h7.89v1.23h-7.89c-1.72 0-3.11-1.45-3.11-3.25V5.443c0-1.79 1.39-3.24 3.11-3.24h11.78c1.72 0 3.11 1.45 3.11 3.24",
  fill: "#7D7D7D"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(1 6.143)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "t078asopyb",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#o9srnp685a"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#979797",
  xlinkHref: "#o9srnp685a"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7D7D7D",
  mask: "url(#t078asopyb)",
  d: "M-4 7.1h25.333V-4.1H-4z"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#7D7D7D",
  xlinkHref: "#dgqs0ezi3c",
  transform: "translate(5 .143)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#7D7D7D",
  xlinkHref: "#xxf6v25jld",
  transform: "translate(12 .143)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.667 15.973v1.23h-3v2.5c0 .14 0 .3-.01.44h-1.18c.01-.14.01-.3.01-.44v-2.5h-2.82v-1.23h2.82v-2.83h1.18v2.83h3z",
  fill: "#7D7D7D"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgAddToCalendar);
export default ForwardRef;